// src/config.js

// 设置为 true 时调用实际后端 API，设置为 false 时使用模拟数据
// 你也可以将这个设置为环境变量
export const USE_REAL_API = process.env.VUE_APP_USE_REAL_API === 'true'; // 例如从环境变量读取

// 根据当前环境从环境变量中读取后端 API 基础 URL
// VUE_APP_API_BASE_URL 将在 .env.development 或 .env.production 中定义
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

// 您可以在这里添加其他全局配置，同样可以从环境变量读取
// export const ANOTHER_CONFIG = process.env.VUE_APP_ANOTHER_CONFIG;
